import { ORPCError } from "@orpc/client";
import { isAxiosError } from "axios";

// Both transports reject proposals when their source changed after generation.
export const isStaleProposalError = (error: unknown): boolean =>
  (error instanceof ORPCError && error.code === "CONFLICT") ||
  (isAxiosError<{ code?: string }>(error) &&
    error.response?.status === 409 &&
    error.response.data?.code === "stale_proposal");
